import Icon from 'components/Icon'
import CheckMarkIcon from 'components/Icon/icons/check-mark'
import { View } from 'components/View'
import {
  FEATURE_MESSAGES,
  FREE_FEATURE_MESSAGES,
  PREMIUM_PLUS_FEATURE_MESSAGES
} from 'modules/app/constants/features'
import {
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import React from 'react'
import SubscriptionPlanFeatureLine from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/FeatureLine/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  bestFor: {
    id: 'SubscriptionPremiumPlusPlanFeatures.bestFor',
    defaultMessage: 'For beginners or casual fitness lovers'
  }
})

/**
 * @param props
 * @param props.isSummary
 * @param props.areFeaturesPressable
 * @returns {Element}
 * @constructor
 */
export function SubscriptionFreePlanFeatures (props) {
  const {
    isSummary,
    areFeaturesPressable
  } = props
  const intl = useIntl()
  const messagesArr = isSummary
    ? [
        ...PREMIUM_PLUS_FEATURE_MESSAGES.slice(0, 2),
        ...FREE_FEATURE_MESSAGES
      ]
    : FEATURE_MESSAGES

  return (
    <View>
      <TextBodySmaller
        c='paragraph'
        mb={isSummary ? 2 : 1}
        style={{
          textAlign: isSummary ? 'left' : 'center'
        }}
      >
        {formatMessageIntlUtil(intl, messages.bestFor)}
      </TextBodySmaller>

      {
        messagesArr.map((message, index) => {
          const isChecked = FREE_FEATURE_MESSAGES.includes(message)
          return (
            <View
              key={index}
              style={{
                flexDirection: View.DIRECTION.ROW,
                lineHeight: '1em',
                opacity: isChecked ? '1' : '0.3'
              }}
              mt={1.5}
            >
              <div
                style={{
                  paddingRight: STYLES_PADDING.SMALL,
                  color: STYLES_COLOR.BLUE
                }}
              >
                <Icon
                  icon={CheckMarkIcon}
                  size={Icon.SIZE.SMALLER}
                />
              </div>

              <SubscriptionPlanFeatureLine
                areFeaturesPressable={areFeaturesPressable}
                message={message}
              />
            </View>
          )
        })
      }
    </View>
  )
}
